
export default function updateWithPriors(priorsA, toUpdateListA, updateListHasPriority){

    var priors = JSON.parse(JSON.stringify(priorsA));
    var toUpdateList = JSON.parse(JSON.stringify(toUpdateListA));

    if (priors.length === 0){
      return toUpdateList;
    }

    do{
      var aPrior = priors.shift();

      var newUpdates = [];
      if (toUpdateList.length === 0){
        return [];
      }

      do{

        var anUpdate = toUpdateList.shift();
        var priorDepth = aPrior.w;

        // if (depthComparison === "match"){
            var isContinue = sameLevelMeld(aPrior, anUpdate, newUpdates, priors, updateListHasPriority, priorDepth); 
            if (!isContinue){
              for (var i3 = 0; i3 < toUpdateList.length; i3++){
                newUpdates.push(toUpdateList[i3]);
              }
              toUpdateList = [];
            }
        // }else{
        //   newUpdates.push(anUpdate);
        // }

      }while (toUpdateList.length > 0);

      toUpdateList = newUpdates;

    }while (priors.length > 0);

    return toUpdateList;
}

function getComparisonDepth(item){
  if (item.t === 'r'){
    return item.w.concat(item.i);
  }else{
    return item.w;
  }
}

// function compareTwoDepths(priorDepth, currentDepth){
//   if (currentDepth.length === priorDepth.length){
//     for (var i = 0; i < priorDepth.length; i++){
//       if (currentDepth[i] !== priorDepth[i]){
//         return false;
//       }
//     }
//     return true;
//   }else{
//     return false;
//   }
// }


export function sameLevelMeld(aPrior, anUpdate, newUpdates, priors, updateListHasPriority, priorDepth){

  var compare = compareDepthsScaled(aPrior, anUpdate);
  if (compare === 'aPriorHigher'){
    return true;
  }else if (compare === 'anUpdateHigher'){
    newUpdates.push(anUpdate);
    return false;
  }else if (!compare){
    newUpdates.push(anUpdate);
    return true;
  }


  if (aPrior.t === 'a'){
    if (anUpdate.t === 'a'){
      if (aPrior.p < anUpdate.p){
        anUpdate.p = anUpdate.p + aPrior.n.length;
      }else if (aPrior.p === anUpdate.p){
        if (updateListHasPriority){
          aPrior.p = anUpdate.n.length + aPrior.p
        }else{
          anUpdate.p = anUpdate.p + aPrior.n.length;
        }
      }else{
        aPrior.p = anUpdate.n.length + aPrior.p
      }
      newUpdates.push(anUpdate);

    }else if (anUpdate.t === 'd'){  
      if (aPrior.p <= anUpdate.p){
        anUpdate.p = anUpdate.p + aPrior.n.length;
        newUpdates.push(anUpdate);
      }else if (anUpdate.p + anUpdate.l <= aPrior.p){
        newUpdates.push(anUpdate);
        aPrior.p = aPrior.p - anUpdate.l;
      }else{
        var origLength = anUpdate.l;
        var anotherD = {t:'d',w:priorDepth,p:anUpdate.p + aPrior.n.length,l:origLength - (aPrior.p - anUpdate.p)};
        anUpdate.l = aPrior.p - anUpdate.p;
        newUpdates.push(anUpdate);
        newUpdates.push(anotherD);
        aPrior.p = anUpdate.p;
      }
    }else{
      console.warn(anUpdate);
      console.warn(aPrior);
    }
  }else if (aPrior.t === 'd'){
    if (anUpdate.t === 'a'){
      if (anUpdate.p <= aPrior.p){
        aPrior.p = aPrior.p + anUpdate.n.length;
      }else if (aPrior.p + aPrior.l <= anUpdate.p){
        anUpdate.p  = anUpdate.p - aPrior.l;
      }else{
        var anotherD2 = {t:'d',w:priorDepth,p:aPrior.p+anUpdate.n.length,l:aPrior.l - anUpdate.p + aPrior.p};
        aPrior.l = anUpdate.p - aPrior.p;
        priors.push(anotherD2);
        anUpdate.p = aPrior.p;
      }
      newUpdates.push(anUpdate);


    }else if (anUpdate.t === 'd'){
      if (aPrior.p === anUpdate.p){
        if (aPrior.l === anUpdate.l){
          return false;
        }else if (aPrior.l > anUpdate.l){
          aPrior.l = aPrior.l - anUpdate.l;
          //don't add to updates;
        }else{
          anUpdate.l = anUpdate.l - aPrior.l;
          newUpdates.push(anUpdate);
          //end this prior.
          return false;
        }
      }else if (aPrior.p < anUpdate.p){
        if (aPrior.p + aPrior.l <= anUpdate.p){
          anUpdate.p = anUpdate.p - aPrior.l;
          newUpdates.push(anUpdate);
        }else if (aPrior.p + aPrior.l === anUpdate.p + anUpdate.l){
          //don't add to update.
          aPrior.l = anUpdate.p - aPrior.p;
        }else if (aPrior.p + aPrior.l > anUpdate.p + anUpdate.l){
          var anotherD3 = {t:'d',p:aPrior.p,l:aPrior.p + aPrior.l - anUpdate.p - anUpdate.l,w:priorDepth};
          aPrior.l = anUpdate.p - aPrior.p;
          priors.push(anotherD3);
          //don't add to update.          
        }else{
          anUpdate.l = anUpdate.p + anUpdate.l - aPrior.p - aPrior.l;
          aPrior.l = anUpdate.p - aPrior.p;
          anUpdate.p = aPrior.p;
          newUpdates.push(anUpdate);
        }

      }else{
        if (anUpdate.p + anUpdate.l <= aPrior.p){
          newUpdates.push(anUpdate);
          aPrior.p = aPrior.p - anUpdate.l;
        }else if (anUpdate.p + anUpdate.l === aPrior.p + aPrior.l){
          anUpdate.l = aPrior.p - anUpdate.p;
          newUpdates.push(anUpdate);
          return false;
        }else if (anUpdate.p + anUpdate.l > aPrior.p + aPrior.l){
          var anotherD4 = {t:'d',p:anUpdate.p, l:anUpdate.p + anUpdate.l - aPrior.p - aPrior.l, w:priorDepth};
          anUpdate.l = aPrior.p - anUpdate.p;
          newUpdates.push(anUpdate);
          newUpdates.push(anotherD4);

          return false;
        }else{
          aPrior.l = aPrior.p + aPrior.l - anUpdate.p - anUpdate.l;
          anUpdate.l = aPrior.p - anUpdate.p;
          aPrior.p = anUpdate.p;
          newUpdates.push(anUpdate);
        }

      }

    }else{
      console.warn(anUpdate);
      console.warn(aPrior);
    }
  }else if (aPrior.t === 'w' || aPrior.t === 'r'){ // i guess the questions we are trying to answer here is, (a) how do we need to modify anUpdate if suddenly there was aPrior that happened before it; (b) how would we need to modify aPrior if suddenly there was anUpdate that happened before it.
    if (updateListHasPriority){
      newUpdates.push(anUpdate);
      return false;
    }else{
    }
  }
  return true;
}

function compareDepthsScaled(aPrior, anUpdate){
  var priorDepth = getComparisonDepth(aPrior);
  var updateDepth = getComparisonDepth(anUpdate);
  var a;
  var maxCheck
  if (priorDepth.length > updateDepth.length){
    maxCheck = updateDepth.length;
    a = "anUpdateHigher";
  }else if (priorDepth.length === updateDepth.length){
    maxCheck = updateDepth.length;
    a = "equalHeight";
  }else{
    maxCheck = priorDepth.length;
    a = "aPriorHigher";
  }
  for (var i = 0; i < maxCheck.length; i++){
    if (priorDepth[i] !== updateDepth[i]){
      return false;
    }
  }
  return a;
}

